module.exports = __webpack_public_path__ + "/images/ln-hero-af-cuna.1bf20ee.png";